<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.eventCode" clearable placeholder="事件" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.mailTo" clearable placeholder="收件人" style="width:180px" @keyup.enter.native="search" />
      <el-select v-model="query.status" clearable placeholder="状态" style="width:120px">
        <el-option label="成功" value="1" />
        <el-option label="失败" value="2" />
      </el-select>
      <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" start-placeholder="起" end-placeholder="止" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="createDate" label="时间" width="170" />
      <el-table-column prop="eventCode" label="事件" width="160" />
      <el-table-column prop="mailTo" label="收件人" width="200" />
      <el-table-column prop="subject" label="主题" min-width="180" show-overflow-tooltip />
      <el-table-column label="状态" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="row.status === '1' ? 'success' : (row.status === '2' ? 'danger' : 'info')">{{ statusLabel(row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="errorMsg" label="错误信息" min-width="200" show-overflow-tooltip />
    </el-table>
    <list-pagination :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" @current-change="onPage" @size-change="onSize" />
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listEmailLog } from '../../api/email'

export default {
  components: { ListPagination },
  data() {
    return {
      query: { eventCode: '', mailTo: '', status: '' },
      dateRange: null,
      list: [], total: 0, page: 1, pageSize: 20, loading: false
    }
  },
  created() { this.load() },
  methods: {
    statusLabel(s) { return s === '1' ? '成功' : s === '2' ? '失败' : '待发' },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listEmailLog({
        currentPage: this.page, pageSize: this.pageSize,
        eventCode: this.query.eventCode, mailTo: this.query.mailTo, status: this.query.status,
        dateFrom: this.dateRange && this.dateRange[0], dateTo: this.dateRange && this.dateRange[1]
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    }
  }
}
</script>
